// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-search
{
    /* background-color: white; */
    width: 1200px;
    /* max-width: 100%; */
    overflow: scroll;
    border-radius: 14px;
    margin-top: 30px;
    margin-bottom: 30px;
    height: calc(100vh - (36px + 140px));
    overflow-y: scroll;
    padding-bottom: 30px;
    /* border: 1px solid #EEE; */
}



@media(max-width:1175px){
    .table-search
    {
        width: 800px;
    }
}
@media(max-width:550px){
    .table-search
    {
        width: 398px;
    }
}

.table-search .table-header{
    display: flex;
    width: 1200px;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    border-bottom: 1px solid #efefef;
    padding: 14px 25px;
    background-color: white;

    
}

.table-search .table-header .table-cell{
    font-weight: 700;
    text-align: center;
    width: 160px;
}

.table-search .table-body .body-row{
    display: flex;
    width: 1200px;
    align-items: center;
    justify-content: space-between;
    padding: 14px 25px;
    border-bottom: 1px solid #EEE;
    background-color: white;

}

 .cell-address{
    width: 180px;
}

.table-search .table-body .body-row .cell{
    text-align: center;
    color: #6e707f;
    font-size: 15px;
    word-wrap: break-word;
  overflow-wrap: break-word;
  background-color: white;
    width: 160px;
}

.table-search .table-body .body-row .cell .website-link{
    text-decoration: none;
    color: #28a745;
}
.table-search .table-body .body-row .verififed-cell{
    color: #004085;
    font-weight: 600;
    width: 110px;
    border-radius: 15px;
    padding: 2px 0px;
    background-color: #cce5ff;
}

.table-search .table-body .body-row .not-verififed-cell{
    font-weight: 600;
    width: 110px;
    border-radius: 15px;
    padding: 2px 0px;
    background-color: #f8d7da;
    color: #721c24;
    margin: 0px 4px;
}

.table-search .table-body .get-post-btn button {
    background-color: var(--main-color);
    color: white;
    font-weight: bold;
    border-radius: 22px;
    padding: 10px 20px;
    cursor: pointer;
    border: none;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Utils/searchforpage.css"],"names":[],"mappings":"AAAA;;IAEI,6BAA6B;IAC7B,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;IAClB,oBAAoB;IACpB,4BAA4B;AAChC;;;;AAIA;IACI;;QAEI,YAAY;IAChB;AACJ;AACA;IACI;;QAEI,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,uBAAuB;;;AAG3B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;;AAE3B;;CAEC;IACG,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,qBAAqB;EACvB,yBAAyB;EACzB,uBAAuB;IACrB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB","sourcesContent":[".table-search\n{\n    /* background-color: white; */\n    width: 1200px;\n    /* max-width: 100%; */\n    overflow: scroll;\n    border-radius: 14px;\n    margin-top: 30px;\n    margin-bottom: 30px;\n    height: calc(100vh - (36px + 140px));\n    overflow-y: scroll;\n    padding-bottom: 30px;\n    /* border: 1px solid #EEE; */\n}\n\n\n\n@media(max-width:1175px){\n    .table-search\n    {\n        width: 800px;\n    }\n}\n@media(max-width:550px){\n    .table-search\n    {\n        width: 398px;\n    }\n}\n\n.table-search .table-header{\n    display: flex;\n    width: 1200px;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    border-bottom: 1px solid #efefef;\n    padding: 14px 25px;\n    background-color: white;\n\n    \n}\n\n.table-search .table-header .table-cell{\n    font-weight: 700;\n    text-align: center;\n    width: 160px;\n}\n\n.table-search .table-body .body-row{\n    display: flex;\n    width: 1200px;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 25px;\n    border-bottom: 1px solid #EEE;\n    background-color: white;\n\n}\n\n .cell-address{\n    width: 180px;\n}\n\n.table-search .table-body .body-row .cell{\n    text-align: center;\n    color: #6e707f;\n    font-size: 15px;\n    word-wrap: break-word;\n  overflow-wrap: break-word;\n  background-color: white;\n    width: 160px;\n}\n\n.table-search .table-body .body-row .cell .website-link{\n    text-decoration: none;\n    color: #28a745;\n}\n.table-search .table-body .body-row .verififed-cell{\n    color: #004085;\n    font-weight: 600;\n    width: 110px;\n    border-radius: 15px;\n    padding: 2px 0px;\n    background-color: #cce5ff;\n}\n\n.table-search .table-body .body-row .not-verififed-cell{\n    font-weight: 600;\n    width: 110px;\n    border-radius: 15px;\n    padding: 2px 0px;\n    background-color: #f8d7da;\n    color: #721c24;\n    margin: 0px 4px;\n}\n\n.table-search .table-body .get-post-btn button {\n    background-color: var(--main-color);\n    color: white;\n    font-weight: bold;\n    border-radius: 22px;\n    padding: 10px 20px;\n    cursor: pointer;\n    border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
